export default __webpack_public_path__ + "static/media/firefox_2018-01-30_23-46-42.a1d5411d.png";